import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const FinancePaymentRoutes = defineRoute({
    create: {
        route: {
            path: "/finance-payment/create/:id",
            component: () => loadView(import("./FinancePaymentCreate.vue")),
        },
        build(id: string) {
            return `/finance-payment/create/${id}`;
        },
    },
    update: {
        route: {
            path: "/finance-payment/update/:id",
            component: () => loadView(import("./FinancePaymentUpdate.vue")),
        },
        build(id: string) {
            return `/finance-payment/update/${id}`;
        },
    },
});
